import { ActiveProposalsPanel } from '../components/active-proposals-panel/ActiveProposalsPanel'
import { ParticipateInDaoBanner } from '../components/participate-in-dao-banner/ParticipateInDaoBanner'
import { VotingPowerDelegationPanel } from '../components/voting-power-delegation-panel/VotingPowerDelegationPanel'
import { Proposal } from '../types'
import { PageLayout } from '@/ui/layouts/PageLayout'

export interface GuestViewProps {
  proposals: Proposal[]
  openConnectWalletModal: () => void
}

export function GuestView({ proposals, openConnectWalletModal }: GuestViewProps) {
  return (
    <PageLayout>
      <h1 className="typography-heading-1">Spark Governance</h1>
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-5">
          <VotingPowerDelegationPanel variant="no-delegation" isConnected={false} action={openConnectWalletModal} />
          <ActiveProposalsPanel proposals={proposals} />
        </div>
        <ParticipateInDaoBanner />
      </div>
    </PageLayout>
  )
}
